import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../services/auth/auth.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const router = inject(Router);
  const authService = inject(AuthService);
  const severities = ['info', 'success', 'secondary', 'warn', 'error'];

  return next(req).pipe(
    catchError((error) => {
      const errors: { summary: string; detail: string }[] = [];

      if (error.status === 401) {
        authService.logout();
        authService.setRedirectUrl(router.url);
        router.navigate(['/login']);

        errors.push({
          summary: 'Błąd uwierzytelniania',
          detail: 'Twoja sesja wygasła. Zaloguj się ponownie.'
        });

      } else if (error.status === 403) {
        errors.push({
          summary: 'Brak dostępu',
          detail: 'Nie posiadasz uprawnień.'
        });

      } else if (error.status !== 422) {
        errors.push({
          summary: `Błąd: ${error.status}`,
          detail: `Wiadomość:\n ${error.error.message}`
        });

      } /*else if (error.status === 422) {
        console.log('\t> Error: ', error);
        Object.keys(error.error.validationErrors).forEach((key) => {
          errors.push({
            summary: `Błąd walidacji`,
            detail: `Pole (${key}): \n ${Object.values(error.error.validationErrors[key]).map((row: any) => {
              return `\t- ${row.replaceAll(key+' ', '')}`;
            }).join('\n')}`
          });
        });
      }*/

      for (let i = 0; i < errors.length; i++) {
        messageService.add({
          severity: severities[Math.round(error.status / 100) - 1],
          summary: errors[i].summary,
          detail: errors[i].detail,
          life: 15000,
        });
      }

      return throwError(() => error);
    })
  );
};
